import gql from 'graphql-tag';

export default gql`
  fragment mailFormVersionPreleadProjectUrlClickActivityFragment on MailFormVersionPreleadProjectUrlClickActivity {
    mailFormVersionUrl {
      url
    }
  }
`;
